import { useEffect, useRef, useState, useContext } from 'react';
import { initQuagga, stopQuagga, listenHardwareBarcode } from '../services/barcode';
import { OfflineContext } from '../contexts/OfflineContext';

export default function BarcodeScanner({ onDetected }) {
  const videoRef = useRef(null);
  const [cameraMode, setCameraMode] = useState(false);
  const { online } = useContext(OfflineContext);

  useEffect(() => {
    listenHardwareBarcode(onDetected);
  }, [onDetected]);

  const startCamera = () => {
    setCameraMode(true);
    setTimeout(() => {
      if (videoRef.current) initQuagga(videoRef.current, (code) => {
        onDetected(code);
        stopQuagga();
        setCameraMode(false);
      });
    }, 100);
  };

  return (
    <div>
      {cameraMode && <div ref={videoRef} className="w-full max-w-md" />}
      <button onClick={startCamera} className="bg-blue-500 text-white px-3 py-1 rounded mb-2">Scan with camera</button>
    </div>
  );
}